import { gql } from '@provision/graphql-client';
import {
  NOTIFICATION_PREFERENCE_FRAGMENT,
  NOTIFICATION_PREFERENCE_RELATIONS_FRAGMENT,
  NOTIFICATION_ROLE_FRAGMENT,
} from './notifications.fragment';

export const GET_NOTIFICATION_CHANNEL_QUERY = gql`
  query GetNotificationChannel($params: QueryParams) {
    getNotificationChannel(queryParams: $params) {
      records {
        id
        name
        isActive
      }
    }
  }
`;

export const GET_NOTIFICATION_EVENT_QUERY = gql`
  query GetNotificationEvent($params: QueryParams) {
    getNotificationEvent(queryParams: $params) {
      records {
        id
        notificationEventId
        name
        category
        roles {
          ...NotificationRoleFields
        }
        defaultRoles {
          ...NotificationRoleFields
        }
      }
    }
  }
  ${NOTIFICATION_ROLE_FRAGMENT}
`;

export const GET_NOTIFICATION_PREFERENCE_QUERY = gql`
  query GetNotificationPreference($params: QueryParams) {
    getNotificationPreference(queryParams: $params) {
      records {
        ...NotificationPreferenceFields
        ...NotificationPreferenceRelations
      }
    }
  }
  ${NOTIFICATION_PREFERENCE_FRAGMENT}
  ${NOTIFICATION_PREFERENCE_RELATIONS_FRAGMENT}
`;

export const GET_NOTIFICATION_ROLE_QUERY = gql`
  query GetNotificationRole($params: QueryParams) {
    getNotificationRole(queryParams: $params) {
      records {
        ...NotificationRoleFields
      }
    }
  }
  ${NOTIFICATION_ROLE_FRAGMENT}
`;

export const MANAGE_NOTIFICATION_PREFERENCE_QUERY = gql`
  mutation ManageNotificationPreference($data: ManageNotificationPreferencesInput!) {
    manageNotificationPreferences(params: $data) {
      notificationPreferences {
        ...NotificationPreferenceFields
        ...NotificationPreferenceRelations
      }
      __typename
    }
  }
  ${NOTIFICATION_PREFERENCE_FRAGMENT}
  ${NOTIFICATION_PREFERENCE_RELATIONS_FRAGMENT}
`;
